import api from './axios';

export const authAPI = {
  register: (userData) => api.post('/auth/register', userData),
  login: (email, password) => api.post('/auth/login', { email, password }),
  getCurrentUser: () => api.get('/users/me'),
  updateProfile: (userData) => api.put('/users/me', userData),
};

export const productAPI = {
  getProducts: (categoryId, skip = 0, limit = 40) =>
    api.get('/products', { params: { category_id: categoryId, skip, limit } }),
  countProducts: (categoryId) =>
    api.get('/products/count', { params: { category_id: categoryId || undefined } }),
  getFeaturedProducts: () => api.get('/products/featured'),
  searchProducts: (query) => api.get('/products/search', { params: { q: query } }),
  getProduct: (id) => api.get(`/products/${id}`),
  getProductsByIds: (ids) => api.get('/products/by-ids', { params: { ids: ids.join(',') } }),
  getProductReviews: (id) => api.get(`/products/${id}/reviews`),
  createReview: (id, { rating, comment, reviewer_name, image }) => {
    const form = new FormData();
    form.append('rating', rating);
    form.append('comment', comment);
    if (reviewer_name) form.append('reviewer_name', reviewer_name);
    if (image) form.append('image', image);
    return api.post(`/products/${id}/reviews`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};

export const categoryAPI = {
  getCategories: () => api.get('/categories'),
  createCategory: (categoryData) => api.post('/categories', categoryData),
};

export const cartAPI = {
  getCart: () => api.get('/cart'),
  addToCart: (cartData) => api.post('/cart', cartData),
  updateCartItem: (itemId, quantity) =>
    api.put(`/cart/${itemId}`, { quantity }),
  removeFromCart: (itemId) => api.delete(`/cart/${itemId}`),
  clearCart: () => api.delete('/cart'),
};

export const orderAPI = {
  getOrders: () => api.get('/orders'),
  getOrder: (id) => api.get(`/orders/${id}`),
  createOrder: (orderData) => api.post('/orders', orderData),
  createGuestOrder: (orderData) => api.post('/orders/guest', orderData),
  updateOrderStatus: (id, status) =>
    api.put(`/orders/${id}/status`, { status }),
};
